export default function initMobileMenu() {
  const mobileMenu = document.querySelector('.navbar-collapse');
  const classActive = 'opened';
  let mobileOpened = false;
  let scrollY = 0;
  
  mobileMenu.querySelectorAll('.dropdown-container').forEach(function(collapse) {
    const parent = collapse.parentElement;
    
    collapse.addEventListener('hide.bs.collapse', event => {
      mobileMenu.classList.remove(classActive);
      parent.classList.remove(classActive);
    })
    collapse.addEventListener('show.bs.collapse', event => {
      mobileMenu.classList.add(classActive);
      parent.classList.add(classActive);
    })
  });

  mobileMenu.addEventListener('hide.bs.collapse', event => {
    if(event.target.classList.contains('navbar-collapse')) {

      document.body.classList.remove('not-scroll');

      window.scrollTo({
        top: scrollY,
        behavior: 'instant'
      });
    }
  });
  mobileMenu.addEventListener('show.bs.collapse', event => {
    if(event.target.classList.contains('navbar-collapse')) {
      scrollY = window.scrollY;
      document.body.classList.add('not-scroll');
    }

  });
}